export default {
  departmentBusiness: {
    addButton: '新建部门间交易',
    editTitle: '编辑部门间交易',
    detailTitle: '部门间交易详情',
    departmentBusinessId: 'tradeNo',
    status: '状态',
    businessType: '交易类型',
    sellDepartment: '卖出部门',
    buyDepartment: '买入部门',
    productName: '商品描述',
    supplierName: '供应商',
    businessNumber: '交易数量',
    businessPrice: '交易价格(含税)',
    businessPrice1: '交易金额(含税)',
    postTime: '过账日期',
    orderMakeTime: '制单日期',
    tradeCreateDateStart: '制单开始日期',
    tradeCreateDateEnd: '制单结束日期',
    orderMakeName: '制单人',
  },
  departmentBusinessAdd: {
    productTable: {
      addBtn: '新增行项目',
      index: '序号',
      productNo: '商品编码',
      productName: '商品描述',
      sellLot: '卖出批次',
      buyBatch: '买入批次',
      businessNumber: '交易数量',
      businessPiece: '交易件数',
      unit: '单位',
      businessPrice: '交易价格（含税）',
      businessAmount: '交易金额（含税）',
      businessTradeAvgPrice: '成本价（业务）',
      financeTradeAvgPrice: '成本价（财务）',
      businessInputTaxCode: '进项税码（表外）',
      businessInputTaxAccount: '进项税金科目（表外）',
      financeInputTaxCode: '进项税码（表内）',
      financeInputTaxAccount: '进项税金科目（表内）',
      financeInputTaxAmount: '进项税额',
      businessOutputTaxCode: '销项税码（表外）',
      businessOutputTaxAccount: '销项税金科目（表外）',
      financeOutputTaxCode: '销项税码（表内）',
      financeOutputTaxAccount: '销项税金科目（表内）',
      financeOutputTaxAmount: '销项税额',
    },
    businessTitle: '交易信息',
    financeTitle: '财务信息',
    productTitle: '商品信息',
    businessId: '交易单号',
    compnany: '公司',
    department: '部门',
    fisCalYear: '会计年度',
    sellCompany: '卖出公司',
    sellWareHouse: '卖出仓库',
    buyCompany: '买入公司',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    postDate: '凭证过账日期',
    accountReceive: '应收会计凭证',
    accountPay: '应付会计凭证',
    receivePayDate: '应收应付过账日期',
    receiveVoucher: '冲销应收凭证',
    payVoucher: '冲销应付凭证',
    ajustmentVoucher: '税金调整凭证',
    taxAjustmentVoucher: '冲销税金调整凭证',
    planCostVoucher: '计划成本会计凭证',
    reversePlanCostVoucher: '冲销计划成本会计凭证',
    materialVoucher: '物料凭证号',
    reverseMaterialVoucher: '冲销物料凭证',
    changeStorageTitle: '修改卖出仓库？',
    changeStorageContent: '商品信息将被清空',
    storageEmptyTip: '请选择卖出仓库',
  },
};
